<script setup>
import Icon from '@/Components/Icon.vue';
import mail from '@i/mail.svg?raw';
import phone from '@i/phone.svg?raw';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const companyDetails = computed(() => usePage().props.company_details);
const termsAndConditions = computed(() => usePage().props.template_options.global.terms_and_conditions);
const privacyStatement = computed(() => usePage().props.template_options.global.privacy_statement);
const options = computed(() => usePage().props.template_options);
</script>

<template>
    <p
        v-if="options.footer.contact_footer_title"
        class="mb-4 text-xl font-black md:text-3xl"
    >
        {{ options.footer.contact_footer_title }}
    </p>

    <div class="mt-8 grid gap-y-3">
        <p
            v-if="companyDetails.street &&
                companyDetails.postal_code &&
                companyDetails.city &&
                companyDetails.company_name
            "
        >
            {{ companyDetails.company_name }} <br>
            {{ companyDetails.street }} <br>
            {{ companyDetails.postal_code }} {{ companyDetails.city }}
        </p>

        <div
            v-if="companyDetails.phone_number"
            class="mb-3 flex items-center gap-2"
        >
            <Icon
                :icon="phone"
                alt="phone icon"
            />

            <a
        
                :href="`tel:${companyDetails.phone_number}`"
                class="hover:text-primary"
            >
                {{ companyDetails.phone_number }}
            </a>
        </div>

        <div
            v-if="companyDetails.email_address"
            class="mb-3 flex items-center gap-2"
        >
            <Icon
                :icon="mail"
                class="w-4"
                alt="mail icon"
            />

            <a
      
                :href="`mailto:${companyDetails.email_address}`"
                class="hover:text-primary"
            >
                {{ companyDetails.email_address }}
            </a>
        </div>

        <div class="grid gap-2 text-xs">
            <a
                v-if="termsAndConditions"
                asA
                :href="'/storage/' + termsAndConditions"
                target="_blank"
                :text="t('Terms and Conditions')"
                class="underline-offset-4 transition-colors duration-300 hover:underline"
            />
            <a
                v-if="privacyStatement"
                asA
                :href="'/storage/' + privacyStatement"
                target="_blank"
                :text="t('Privacy declaration')"
                class="underline-offset-4 transition-colors duration-300 hover:underline"
            />
        </div>
    </div>
</template>
